module.exports = __webpack_public_path__ + "fonts/varelaround-regular-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Varela_Round/varelaround-regular-webfont.woff
// module id = 3471
// module chunks = 0